
import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config.json";

import {
    Box,
    Button,
    Container,
    Typography,
    Paper,
} from "@mui/material";

const RankingsPage = () => {
    const [rankType, setRankType] = useState(15);
    const [rankList, setRankList] = useState([]);

    const apiEndPoint = config.apiEndPoint + "statistics/";

    const rankingButtons = [
        { id: 15, name: "Trojan" },
        { id: 25, name: "Warrior" },
        { id: 45, name: "Archer" },
        { id: 135, name: "Water" },
        { id: 145, name: "Fire" },
        { id: 2, name: "Money" },
        { id: 3, name: "Virtue" },
        { id: 4, name: "PK" },
        { id: 255, name: "Guilds" },
    ];

    useEffect(() => {
        const fetchRankings = async () => {
            try {
                const { data } = await axios.get(apiEndPoint + rankType);
                setRankList(data);
            } catch (ex) {
                console.log(ex);
            }
        };

        fetchRankings();
    }, [rankType]);

    const getTitle = () => {
        switch (rankType) {
            case 2: return "Money";
            case 3: return "Virtue";
            case 4: return "PK";
            default: return "Power";
        }
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                py: { xs: 5, md: 9 },
                position: "relative",
                overflow: "hidden",
                background:
                    "radial-gradient(ellipse at 50% 0%, rgba(42,190,98,0.13), transparent 42%), radial-gradient(ellipse at 0% 55%, rgba(28,117,61,0.08), transparent 32%), linear-gradient(155deg, #050A07 0%, #0A120D 48%, #050806 100%)",
                color: "#FFFFFF",

                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "2px",
                    background:
                        "linear-gradient(90deg, transparent, #55D878, #B5FFCA, #238B49, transparent)",
                },

                "&:after": {
                    content: '""',
                    position: "absolute",
                    width: 450,
                    height: 450,
                    borderRadius: "50%",
                    right: -240,
                    top: 260,
                    background: "rgba(50,190,91,0.055)",
                    filter: "blur(120px)",
                    pointerEvents: "none",
                },
            }}
        >
            {/* BACKGROUND DECORATION */}
            <Box
                sx={{
                    position: "absolute",
                    width: 350,
                    height: 350,
                    borderRadius: "50%",
                    left: -190,
                    top: 450,
                    background: "rgba(50,190,91,0.045)",
                    filter: "blur(110px)",
                    pointerEvents: "none",
                }}
            />

            <Container
                maxWidth="lg"
                sx={{
                    position: "relative",
                    zIndex: 2,
                }}
            >
                {/* HEADER */}
                <Box
                    sx={{
                        mb: { xs: 4, md: 6 },
                        position: "relative",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            mb: 3,
                        }}
                    >
                        <Box
                            sx={{
                                width: 4,
                                height: 42,
                                borderRadius: "5px",
                                background:
                                    "linear-gradient(180deg, #B5FFCA, #238B49)",
                                boxShadow:
                                    "0 0 18px rgba(85,216,120,0.25)",
                            }}
                        />

                        <Box>
                            <Typography
                                sx={{
                                    color: "#55D878",
                                    fontWeight: 900,
                                    letterSpacing: "3px",
                                    fontSize: "10px",
                                    textTransform: "uppercase",
                                    mb: 0.5,
                                }}
                            >
                                CRITICAL CONQUER / COMPETITIVE RECORDS
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#87988C",
                                    fontSize: "12px",
                                    letterSpacing: "0.5px",
                                }}
                            >
                                The strongest leave their mark.
                            </Typography>
                        </Box>
                    </Box>

                    <Typography
                        component="h1"
                        sx={{
                            fontWeight: 950,
                            color: "#F1FFF4",
                            fontSize: {
                                xs: "39px",
                                sm: "54px",
                                md: "70px",
                            },
                            lineHeight: 1,
                            mb: 2.5,
                            letterSpacing: "-2.5px",
                        }}
                    >
                        HALL OF
                        <Box
                            component="span"
                            sx={{
                                color: "#55D878",
                                display: "block",
                                textShadow:
                                    "0 0 35px rgba(50,190,91,0.14)",
                            }}
                        >
                            CHAMPIONS.
                        </Box>
                    </Typography>

                    <Typography
                        sx={{
                            color: "#92A197",
                            maxWidth: "590px",
                            fontSize: {
                                xs: "13px",
                                md: "15px",
                            },
                            lineHeight: 1.9,
                        }}
                    >
                        Power, wealth, honor, and battle records.
                        Explore the rankings and discover the players
                        and guilds shaping the world of Critical Conquer.
                    </Typography>

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mt: 3,
                        }}
                    >
                        <Box
                            sx={{
                                width: 30,
                                height: 2,
                                background: "#55D878",
                            }}
                        />
                        <Box
                            sx={{
                                width: 8,
                                height: 8,
                                transform: "rotate(45deg)",
                                border: "1px solid #55D878",
                            }}
                        />
                        <Box
                            sx={{
                                width: 65,
                                height: 2,
                                background:
                                    "linear-gradient(90deg, rgba(85,216,120,0.55), transparent)",
                            }}
                        />
                    </Box>
                </Box>

                {/* RANKING CATEGORY SELECTOR */}
                <Box
                    sx={{
                        mb: 3,
                        p: { xs: 2, md: 2.5 },
                        borderRadius: "16px",
                        background:
                            "linear-gradient(135deg, rgba(15,31,20,0.96), rgba(8,15,10,0.96))",
                        border: "1px solid rgba(85,216,120,0.15)",
                    }}
                >
                    <Typography
                        sx={{
                            color: "#789080",
                            fontWeight: 900,
                            letterSpacing: "2px",
                            fontSize: "10px",
                            mb: 2,
                        }}
                    >
                        SELECT LEADERBOARD
                    </Typography>

                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 1,
                        }}
                    >
                        {rankingButtons.map((btn) => (
                            <Button
                                key={btn.id}
                                onClick={() => setRankType(btn.id)}
                                sx={{
                                    minWidth: {
                                        xs: "auto",
                                        sm: "100px",
                                    },
                                    background:
                                        rankType === btn.id
                                            ? "linear-gradient(135deg, #72F5A1, #35B963)"
                                            : "rgba(255,255,255,0.025)",
                                    color:
                                        rankType === btn.id
                                            ? "#07130A"
                                            : "#9BA99F",
                                    border:
                                        rankType === btn.id
                                            ? "1px solid #8EFFB1"
                                            : "1px solid rgba(255,255,255,0.07)",
                                    borderRadius: "8px",
                                    px: { xs: 1.8, sm: 2.2 },
                                    py: 1,
                                    fontWeight: 800,
                                    fontSize: "12px",
                                    textTransform: "none",
                                    letterSpacing: "0.2px",
                                    boxShadow:
                                        rankType === btn.id
                                            ? "0 5px 22px rgba(50,190,91,0.15)"
                                            : "none",
                                    transition: "all 0.2s ease",

                                    "&:hover": {
                                        color:
                                            rankType === btn.id
                                                ? "#07130A"
                                                : "#72F5A1",
                                        borderColor:
                                            "rgba(85,216,120,0.45)",
                                        background:
                                            rankType === btn.id
                                                ? "#A6FFC2"
                                                : "rgba(85,216,120,0.07)",
                                        transform: "translateY(-2px)",
                                    },
                                }}
                            >
                                {btn.name}
                            </Button>
                        ))}
                    </Box>
                </Box>

                {/* LEADERBOARD */}
                <Paper
                    elevation={0}
                    sx={{
                        background:
                            "linear-gradient(155deg, rgba(13,24,16,0.99), rgba(6,11,8,0.99))",
                        border:
                            "1px solid rgba(85,216,120,0.17)",
                        borderRadius: {
                            xs: "15px",
                            md: "20px",
                        },
                        overflow: "hidden",
                        boxShadow:
                            "0 25px 70px rgba(0,0,0,0.35)",
                        position: "relative",

                        "&:before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: "2px",
                            background:
                                "linear-gradient(90deg, transparent, #238B49, #72F5A1, #238B49, transparent)",
                        },
                    }}
                >
                    {/* TABLE TITLE BAR */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: {
                                xs: "column",
                                sm: "row",
                            },
                            alignItems: {
                                xs: "flex-start",
                                sm: "center",
                            },
                            justifyContent: "space-between",
                            gap: 1.5,
                            px: { xs: 2, sm: 3.5 },
                            py: 2.5,
                            borderBottom:
                                "1px solid rgba(255,255,255,0.06)",
                            background:
                                "linear-gradient(90deg, rgba(85,216,120,0.045), transparent)",
                        }}
                    >
                        <Box>
                            <Typography
                                sx={{
                                    color: "#F0FFF3",
                                    fontSize: "17px",
                                    fontWeight: 900,
                                    letterSpacing: "-0.3px",
                                }}
                            >
                                {rankingButtons.find(
                                    (btn) => btn.id === rankType
                                )?.name || "Player"} Rankings
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#748379",
                                    fontSize: "11px",
                                    mt: 0.5,
                                }}
                            >
                                Current standings across the realm
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                px: 1.5,
                                py: 0.8,
                                borderRadius: "6px",
                                border:
                                    "1px solid rgba(85,216,120,0.15)",
                                background: "rgba(85,216,120,0.05)",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#72F5A1",
                                    fontSize: "10px",
                                    fontWeight: 900,
                                    letterSpacing: "1.3px",
                                }}
                            >
                                {getTitle().toUpperCase()} LEADERBOARD
                            </Typography>
                        </Box>
                    </Box>

                    {/* TABLE HEADER */}
                    <Box
                        sx={{
                            display: {
                                xs: "none",
                                sm: "grid",
                            },
                            gridTemplateColumns:
                                rankType === 255
                                    ? "75px 1.5fr 0.8fr 1fr 1fr"
                                    : "75px 1.5fr 0.8fr 1fr 1.2fr",
                            px: 3.5,
                            py: 1.8,
                            borderBottom:
                                "1px solid rgba(85,216,120,0.10)",
                            background: "rgba(0,0,0,0.22)",
                        }}
                    >
                        <HeaderText>#</HeaderText>
                        <HeaderText>Name</HeaderText>
                        <HeaderText>Level</HeaderText>
                        <HeaderText>{getTitle()}</HeaderText>
                        <HeaderText>Guild</HeaderText>
                    </Box>

                    {/* RANKING ROWS */}
                    {rankList.map((player, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: "grid",
                                gridTemplateColumns: {
                                    xs: "44px minmax(0, 1fr)",
                                    sm:
                                        rankType === 255
                                            ? "75px 1.5fr 0.8fr 1fr 1fr"
                                            : "75px 1.5fr 0.8fr 1fr 1.2fr",
                                },
                                alignItems: "center",
                                px: { xs: 2, sm: 3.5 },
                                py: { xs: 2, sm: 2.2 },
                                borderBottom:
                                    index === rankList.length - 1
                                        ? "none"
                                        : "1px solid rgba(255,255,255,0.045)",
                                transition: "all 0.2s ease",
                                position: "relative",

                                background:
                                    index === 0
                                        ? "linear-gradient(90deg, rgba(85,216,120,0.11), rgba(85,216,120,0.015) 70%, transparent)"
                                        : index === 1
                                            ? "rgba(255,255,255,0.018)"
                                            : index === 2
                                                ? "rgba(35,139,73,0.035)"
                                                : "transparent",

                                "&:hover": {
                                    background:
                                        "linear-gradient(90deg, rgba(85,216,120,0.09), rgba(85,216,120,0.015))",
                                },

                                ...(index === 0
                                    ? {
                                        "&:before": {
                                            content: '""',
                                            position: "absolute",
                                            top: 0,
                                            bottom: 0,
                                            left: 0,
                                            width: "3px",
                                            background: "#72F5A1",
                                        },
                                    }
                                    : {}),
                            }}
                        >
                            {/* RANK NUMBER */}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontWeight: 950,
                                        fontSize:
                                            index < 3 ? "16px" : "13px",
                                        color:
                                            index === 0
                                                ? "#72F5A1"
                                                : index === 1
                                                    ? "#CBD7CF"
                                                    : index === 2
                                                        ? "#A5C9AF"
                                                        : "#617067",
                                    }}
                                >
                                    {String(index + 1).padStart(2, "0")}
                                </Typography>
                            </Box>

                            {/* PLAYER NAME */}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    minWidth: 0,
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 37,
                                        height: 37,
                                        minWidth: 37,
                                        mr: 1.5,
                                        borderRadius: "10px",
                                        display: {
                                            xs: "none",
                                            sm: "flex",
                                        },
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background:
                                            index === 0
                                                ? "rgba(85,216,120,0.12)"
                                                : "rgba(255,255,255,0.035)",
                                        border:
                                            index === 0
                                                ? "1px solid rgba(85,216,120,0.28)"
                                                : "1px solid rgba(255,255,255,0.06)",
                                        color:
                                            index === 0
                                                ? "#72F5A1"
                                                : "#829187",
                                        fontSize: "12px",
                                        fontWeight: 900,
                                    }}
                                >
                                    {String(index + 1).padStart(2, "0")}
                                </Box>

                                <Typography
                                    sx={{
                                        fontWeight: 800,
                                        color:
                                            index === 0
                                                ? "#B9FFCD"
                                                : "#E4ECE6",
                                        fontSize: {
                                            xs: "13px",
                                            sm: "14px",
                                        },
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {player.name}
                                </Typography>
                            </Box>

                            {/* LEVEL */}
                            <Typography
                                sx={{
                                    color: "#93A198",
                                    fontWeight: 600,
                                    fontSize: "13px",
                                    display: {
                                        xs: "none",
                                        sm: "flex",
                                    },
                                    alignItems: "center",
                                }}
                            >
                                {player.level}
                            </Typography>

                            {/* POWER / VALUE */}
                            <Typography
                                sx={{
                                    color:
                                        index === 0
                                            ? "#72F5A1"
                                            : "#A7B3AA",
                                    fontWeight: 800,
                                    fontSize: "13px",
                                    display: {
                                        xs: "none",
                                        sm: "flex",
                                    },
                                    alignItems: "center",
                                }}
                            >
                                {player.param?.toLocaleString()}
                            </Typography>

                            {/* GUILD */}
                            <Typography
                                sx={{
                                    color: "#849188",
                                    fontWeight: 600,
                                    fontSize: "13px",
                                    display: {
                                        xs: "none",
                                        sm: "flex",
                                    },
                                    alignItems: "center",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {player.guildName || "-"}
                            </Typography>

                            {/* MOBILE DETAILS */}
                            <Box
                                sx={{
                                    gridColumn: "2",
                                    display: {
                                        xs: "flex",
                                        sm: "none",
                                    },
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    gap: 1,
                                    mt: 0.7,
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#829187",
                                        fontSize: "11px",
                                        fontWeight: 600,
                                    }}
                                >
                                    Lv. {player.level}
                                </Typography>

                                <Box
                                    sx={{
                                        width: 3,
                                        height: 3,
                                        borderRadius: "50%",
                                        background: "#3A8E55",
                                    }}
                                />

                                <Typography
                                    sx={{
                                        color:
                                            index === 0
                                                ? "#72F5A1"
                                                : "#9EADA2",
                                        fontSize: "11px",
                                        fontWeight: 800,
                                    }}
                                >
                                    {player.param?.toLocaleString()}
                                </Typography>

                                <Box
                                    sx={{
                                        width: 3,
                                        height: 3,
                                        borderRadius: "50%",
                                        background: "#53665A",
                                    }}
                                />

                                <Typography
                                    sx={{
                                        color: "#728177",
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        maxWidth: "100%",
                                    }}
                                >
                                    {player.guildName || "-"}
                                </Typography>
                            </Box>
                        </Box>
                    ))}

                    {/* EMPTY STATE */}
                    {rankList.length === 0 && (
                        <Box
                            sx={{
                                py: 10,
                                px: 3,
                                textAlign: "center",
                            }}
                        >
                            <Box
                                sx={{
                                    width: 60,
                                    height: 60,
                                    mx: "auto",
                                    mb: 2.5,
                                    borderRadius: "18px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background:
                                        "rgba(85,216,120,0.06)",
                                    border:
                                        "1px solid rgba(85,216,120,0.14)",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 16,
                                        height: 16,
                                        border: "2px solid #55D878",
                                        transform: "rotate(45deg)",
                                        opacity: 0.8,
                                    }}
                                />
                            </Box>

                            <Typography
                                sx={{
                                    color: "#DDEAE0",
                                    fontWeight: 800,
                                    fontSize: "15px",
                                }}
                            >
                                No Records Found
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#718077",
                                    fontSize: "12px",
                                    mt: 1,
                                    lineHeight: 1.8,
                                }}
                            >
                                There are currently no rankings to display
                                for this category.
                            </Typography>
                        </Box>
                    )}
                </Paper>

                {/* BOTTOM SIGNATURE */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mt: 5,
                        gap: 2,
                    }}
                >
                    <Box
                        sx={{
                            width: { xs: 30, sm: 70 },
                            height: "1px",
                            background:
                                "linear-gradient(90deg, transparent, rgba(85,216,120,0.4))",
                        }}
                    />

                    <Typography
                        sx={{
                            color: "#536359",
                            fontSize: "10px",
                            fontWeight: 800,
                            letterSpacing: {
                                xs: "1.2px",
                                sm: "2.5px",
                            },
                            textTransform: "uppercase",
                            textAlign: "center",
                        }}
                    >
                        Earn Your Place Among Legends
                    </Typography>

                    <Box
                        sx={{
                            width: { xs: 30, sm: 70 },
                            height: "1px",
                            background:
                                "linear-gradient(90deg, rgba(85,216,120,0.4), transparent)",
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
};

const HeaderText = ({ children }) => (
    <Typography
        sx={{
            color: "#72F5A1",
            fontWeight: 800,
            fontSize: "10px",
            letterSpacing: "1.8px",
            textTransform: "uppercase",
        }}
    >
        {children}
    </Typography>
);

export default RankingsPage;
